<!-- /parent/selfcheckout
parent self checkout -->

<template>
  <div class="wrapper">
    <div v-if="loading_submit" class="loading_overlay">
      <div class="loading_spinner"></div>
    </div>
    <div v-if="error_message" class="error_overlay">
      <div class="error_message">{{ error_message }}</div>
    </div>
    <div class="container_wrapper">
      <div class="title_section">
        <div class="title">
          IFGF IKIDS Parent Self Check In / Check Out
        </div>
        <div class="scan">
          <input
            id="scan_input"
            class="scan_input"
            type="text"
            v-model="form.value"
            ref="text"
            placeholder="Scan QR Code."
            @input="changeHandler"
            @blur.prevent="focusTextbox"
            >
            </input>
          <div class="btn_scan" @click="scan">Scan</div>
          <div class="btn_clear" @click="clearPage">Clear</div>
        </div>
      </div>
      <div class="content_section">
        <div class="in_section" v-if="data_checkin.length > 0">
          <div class="card_container">
            <div v-for="item in data_checkin" :key="item.id" class="card1">
              <div class="card_content">
                <div class="card_header">
                  <div class="card_gender">
                    <img v-if="item.sex == 'male'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACdUlEQVR4nO1Y3WoTQRQ+WO/8uRVs0p1JAkL1HbzwSgTxQkHQBxDTRt+gD+BVdM9ZhfoCuVRQn8NWsH0BEYU2c7orVkPkbCgk002T/c1G9oOBZZk9830z528WoEKFChX+e2jiYdoBlYAUqE6AFuxC80ATP1Bk/pQyBtKS12UWoKPIo/m7FAL0NPIePyq9gLPIQ0TmgmUiX2oB85AvrQDtmvvzkM9dgHIDRyFvajSfFPGeJj6SET7LO+RNmZOUfG4CWl2/ponfzMrZo2EGmri39vJAxyWfiwCHjm4r5MPYfQ3yL0VWXp9BPnMBobuMdjR1Wywn4RA/nLWmzkqAov7dKPKKzGcRtuaZ9Ssvvl2QIc+KuKPQ7EQL6A808uN51tVZCGhiUFfIZoI4mt8azVPYGp6b+mFvuKKJ2+HcSSJBzfNXoSgo5Lc2+YbLt+b9XuaeEoH8GoqAcgPnVFMlOx8T2uMNaxOOJZtB3lDEHcvnd8U1YhvqDVfk27QbERuazMdJAdyBhHCIn0+eAr+HvKGQ98cXlQyT1FbT5etWHHyFvKGIeXxRSZNJbV3b/nHJOs0+FC1g3f1+MamtVvfnZcuFDmGZXKhBfKNwF9J2ECM/yyyIid9B3lBh/zO5aze3hudjG5KqjPxl3JaD5gkspJB5vJG6nhRVyASKeDuDVuLY6oc8KAqtrl+LbOaI22dWZam+ciuz+iDJPvVX/lUoEmp6O70rgS1F6qSdlmwTBqzl86NhBg3s3ymUfHYXGjMQG7BIOAmvlFIQHTT3oAyoef5q3Eu94x0oKBuaGNQlkDWaD1IfTn6rhM/yjrgtcxbNs0KFChUgd/wDuOQCKSlkqe0AAAAASUVORK5CYII=" alt="male">
                    <img v-if="item.sex == 'female'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACjElEQVR4nO1XMWsUURB+FlpENObcnblTsdIoioLaCXLcztwpmMLCaCHaSUQQxEgKK0UQEWzEWn+ANmJhYQoJiuAviEi0FEUFY1QSMJ/sofH27d7l9rJ3uyf7wev2zfd9b+btmzEmx38EDJY3gOUkSO6DdAqk03/WFEjugfUEhnTQZA3YenQILFfBOgtWtFwk30Fy099jsgAUtQySj8sKDxv5AMc7lK54V86AdSG2+H8m5v0Y6YjnqhcpnuQtWK7VM7OpsgOl2k6QKEhvgfV9hJEFsFfprXi3XATJ55AQkkswB1a3ML22Xv+si0HT+gnkce8MkNwNiXertRj7T4Hll2XiTndV/yUveJvrtRskH48dxy8ztu6Dc7jUHdWNxEU5Hzx9edOqbJrG2TW6BqwzQRPeWHdUNxKTPg6Qunp5BbGuWIfxKFm1UaSsr61T29txLEf2WaU4nazaKFL7td14cN3KWg9tzMDXZNVGkZL+CJCWRgY6jlUaGbDbjGTVRpGSvAuQOjLccSxHhq3f8UyyaqNIWSatuj3XcSzyxqwSmkxWbRQpexOWgVcwZlVnseRl0IA3kbxim9TR7aFX1NXTseMUveNW+Sz6fVN3VNvkpA+syzeHkre/7f1ubRtIvlgGHnZXdaMAv8v0B5OggFkUq6NtdbH2/EAy37PTb34Bl8Q8q4+VW2qFpW8LR9aDvGP+Sxu9R8/2VHzThixsZg6s35YZbG6nIr7BxAWQ/ow9jdXnB71osgBwZTdYn4QGlebrqb/HZA0g3QPW62B5HiH6BUhvZFJ4FGwDpt+A3EDKyDOQNvIMpI3MZwDxW4eWy+QGYiLPAPfZHTH9BuQGUkaegbSRZyBt9H0Gcpj28BtMpvPzfi/P4QAAAABJRU5ErkJggg==" alt="female">
                  </div>
                  <div class="card_title">
                    {{item.firstname + " " + item.lastname}}
                  </div>
                </div>
                <div class="card_body">
                  <div class="card_body_left">
                    <div class="card_image">
                      <img v-bind:src="getPhoto(item.get_photo)">
                    </div>
                  </div>
                  <div class="card_body_right">
                    <div class="card_text">
                      <span>Class: {{ item.ikid_class.name }}</span>
                      <span>Parents:</span>
                      <span>{{ item.dad && (item.dad.firstname || item.dad.lastname) ? (item.dad.firstname || '') + ' ' + (item.dad.lastname || '') : '' }}</span>
                      <span>{{ item.mom && (item.mom.firstname || item.mom.lastname) ? (item.mom.firstname || '') + ' ' + (item.mom.lastname || '') : '' }}</span>
                    </div>
                  </div>
                </div>
                <div class="card_footer">
                  <div class="btn" @click="checkInSelect(item.id)">Check In</div>
                </div>
              </div>
            </div>
          </div>
          <div class="button_submit_container" @click="checkInAll">
            <div class="text_checkin">
              Check In All
            </div>
            <div class="btn_checkin">
              <img src="data:image/png;base64,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" alt="external-check-in-vacation-planning-flaticons-lineal-color-flat-icons-2">
            </div>
          </div>
        </div>
        <div class="out_section" v-if="data_checkout.length > 0">
          <div class="card_container">
            <div v-for="item in data_checkout" :key="item.id" class="card1">
              <div class="card_content">
                <div class="card_header">
                  <div class="card_gender">
                    <img v-if="item.sex == 'male'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACdUlEQVR4nO1Y3WoTQRQ+WO/8uRVs0p1JAkL1HbzwSgTxQkHQBxDTRt+gD+BVdM9ZhfoCuVRQn8NWsH0BEYU2c7orVkPkbCgk002T/c1G9oOBZZk9830z528WoEKFChX+e2jiYdoBlYAUqE6AFuxC80ATP1Bk/pQyBtKS12UWoKPIo/m7FAL0NPIePyq9gLPIQ0TmgmUiX2oB85AvrQDtmvvzkM9dgHIDRyFvajSfFPGeJj6SET7LO+RNmZOUfG4CWl2/ponfzMrZo2EGmri39vJAxyWfiwCHjm4r5MPYfQ3yL0VWXp9BPnMBobuMdjR1Wywn4RA/nLWmzkqAov7dKPKKzGcRtuaZ9Ssvvl2QIc+KuKPQ7EQL6A808uN51tVZCGhiUFfIZoI4mt8azVPYGp6b+mFvuKKJ2+HcSSJBzfNXoSgo5Lc2+YbLt+b9XuaeEoH8GoqAcgPnVFMlOx8T2uMNaxOOJZtB3lDEHcvnd8U1YhvqDVfk27QbERuazMdJAdyBhHCIn0+eAr+HvKGQ98cXlQyT1FbT5etWHHyFvKGIeXxRSZNJbV3b/nHJOs0+FC1g3f1+MamtVvfnZcuFDmGZXKhBfKNwF9J2ECM/yyyIid9B3lBh/zO5aze3hudjG5KqjPxl3JaD5gkspJB5vJG6nhRVyASKeDuDVuLY6oc8KAqtrl+LbOaI22dWZam+ciuz+iDJPvVX/lUoEmp6O70rgS1F6qSdlmwTBqzl86NhBg3s3ymUfHYXGjMQG7BIOAmvlFIQHTT3oAyoef5q3Eu94x0oKBuaGNQlkDWaD1IfTn6rhM/yjrgtcxbNs0KFChUgd/wDuOQCKSlkqe0AAAAASUVORK5CYII=" alt="male">
                    <img v-if="item.sex == 'female'" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACjElEQVR4nO1XMWsUURB+FlpENObcnblTsdIoioLaCXLcztwpmMLCaCHaSUQQxEgKK0UQEWzEWn+ANmJhYQoJiuAviEi0FEUFY1QSMJ/sofH27d7l9rJ3uyf7wev2zfd9b+btmzEmx38EDJY3gOUkSO6DdAqk03/WFEjugfUEhnTQZA3YenQILFfBOgtWtFwk30Fy099jsgAUtQySj8sKDxv5AMc7lK54V86AdSG2+H8m5v0Y6YjnqhcpnuQtWK7VM7OpsgOl2k6QKEhvgfV9hJEFsFfprXi3XATJ55AQkkswB1a3ML22Xv+si0HT+gnkce8MkNwNiXertRj7T4Hll2XiTndV/yUveJvrtRskH48dxy8ztu6Dc7jUHdWNxEU5Hzx9edOqbJrG2TW6BqwzQRPeWHdUNxKTPg6Qunp5BbGuWIfxKFm1UaSsr61T29txLEf2WaU4nazaKFL7td14cN3KWg9tzMDXZNVGkZL+CJCWRgY6jlUaGbDbjGTVRpGSvAuQOjLccSxHhq3f8UyyaqNIWSatuj3XcSzyxqwSmkxWbRQpexOWgVcwZlVnseRl0IA3kbxim9TR7aFX1NXTseMUveNW+Sz6fVN3VNvkpA+syzeHkre/7f1ubRtIvlgGHnZXdaMAv8v0B5OggFkUq6NtdbH2/EAy37PTb34Bl8Q8q4+VW2qFpW8LR9aDvGP+Sxu9R8/2VHzThixsZg6s35YZbG6nIr7BxAWQ/ow9jdXnB71osgBwZTdYn4QGlebrqb/HZA0g3QPW62B5HiH6BUhvZFJ4FGwDpt+A3EDKyDOQNvIMpI3MZwDxW4eWy+QGYiLPAPfZHTH9BuQGUkaegbSRZyBt9H0Gcpj28BtMpvPzfi/P4QAAAABJRU5ErkJggg==" alt="female">
                  </div>
                  <div class="card_title">
                    {{item.firstname + " " + item.lastname}}
                  </div>
                </div>
                <div class="card_body">
                  <div class="card_body_left">
                    <div class="card_image">
                      <img v-bind:src="getPhoto(item.get_photo)">
                    </div>
                  </div>
                  <div class="card_body_right">
                    <div class="card_text">
                      <span>Class: {{ item.ikid_class.name }}</span>
                      <span>Parents:</span>
                      <span>{{ item.dad && (item.dad.firstname || item.dad.lastname) ? (item.dad.firstname || '') + ' ' + (item.dad.lastname || '') : '' }}</span>
                      <span>{{ item.mom && (item.mom.firstname || item.mom.lastname) ? (item.mom.firstname || '') + ' ' + (item.mom.lastname || '') : '' }}</span>
                    </div>
                  </div>
                </div>
                <div class="card_footer">
                  <div class="btn" @click="checkOutSelect(item.id)">Check Out</div>
                </div>
              </div>
            </div>
          </div>
          <div class="button_submit_container_checkout" @click="checkOutAll">
            <div class="text_checkin">
              Check Out All
            </div>
            <div class="btn_checkin">
              <img src="data:image/png;base64,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" alt="external-check-out-vacation-planning-flaticons-lineal-color-flat-icons-2">
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="admin_gear_button" @click="openPinModal">⚙</button>
    <div v-if="showPinModal || showPrintModal" class="admin_modal_overlay">
      <div class="admin_modal">
        <div v-if="showPinModal" class="admin_modal_content">
          <div class="admin_modal_title">Enter PIN</div>
          <input
            class="admin_pin_input"
            type="password"
            v-model="pinInput"
            maxlength="4"
            readonly
          >
          <div class="pin_pad">
            <button class="pin_key" @click="appendPinDigit('1')">1</button>
            <button class="pin_key" @click="appendPinDigit('2')">2</button>
            <button class="pin_key" @click="appendPinDigit('3')">3</button>
            <button class="pin_key" @click="appendPinDigit('4')">4</button>
            <button class="pin_key" @click="appendPinDigit('5')">5</button>
            <button class="pin_key" @click="appendPinDigit('6')">6</button>
            <button class="pin_key" @click="appendPinDigit('7')">7</button>
            <button class="pin_key" @click="appendPinDigit('8')">8</button>
            <button class="pin_key" @click="appendPinDigit('9')">9</button>
            <button class="pin_key" @click="appendPinDigit('0')">0</button>
          </div>
          <button class="pin_enter_button" @click="submitPin">Enter</button>
          <button class="pin_cancel_button" @click="closeAdminPopup">Cancel</button>
        </div>
        <div v-if="showPrintModal" class="admin_modal_content">
          <button class="test_print_button" @click="printDummyLabel">Test Print</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

import axios from 'axios'
import EventBus from '@/eventBus';
import ikid from '@/services/ikid'
import { sendMessageToDiscord } from '@/discordUtils';
import moment from 'moment';


export default {

  components: { QrcodeStream },

  data () {
    return {
      data:[],
      data_checkin:[],
      data_checkout:[],
      id: '',
      class_id: [],
      class_name: [],
      dad_id: [],
      dad_name: [],
      mom_id:[],
      mom_name:[],
      selectedItems: [],
      selectedItemsCheckIn: [],
      selectedItemsCheckOut: [],
      form:{
        value: '',
        from:'portal',
        source_channel: 'parent_self_service',
        executed_by: '',
      },
      value: '',
      error: '',
      camera_hide: false,
      result_hide: true,
      message: '',
      message_hide: true,
      loading_submit: false,
      error_message: '',
      showPinModal: false,
      showPrintModal: false,
      pinInput: '',
      defaultPin: '2020',
    }
  },

  created(){

  },

  mounted(){
    this.$refs.text.focus();
  },

  methods: {
    changeHandler() {
      // prevent double input on scan
      if (this.form.value.length > 0 && this.form.value.endsWith('#')) {
        this.form.value = this.form.value.slice(0, -1);
        this.loading_submit = true;
        this.$refs.text.disabled = true;
        setTimeout(() => {
          this.scan();
          this.$refs.text.disabled = false;
        }, 1000);
      }
    },
    focusTextbox() {
      if (!this.loading_submit) {
        this.$refs.text.focus();
      }
    },
    clearPage() {
      this.data = []
      this.data_checkin = []
      this.data_checkout = []
      this.selectedItems = []
      this.selectedItemsCheckIn = []
      this.selectedItemsCheckOut = []
      this.form.value = null
      this.$refs.text.focus();
    },
    scan() {
      this.loading_submit = true
      var temp_input = this.form.value;
      var self = this;
        ikid.scanKidForParentPage({value:this.form.value})
        .then(res => {
            // const newData = res.data.filter(i => {if (i.checkin_status && i.checkin_status.action == 'check in' ) return i})
            // this.data = newData;
            this.data = res.data;
            this.data_checkin = res.data.filter(i => {if (i.checkin_status && i.checkin_status.action == 'check in' ) return i})
            this.data_checkout = res.data.filter(i => {if (i.checkin_status && i.checkin_status.action == 'in class' ) return i})
            this.selectedItems = this.data.map(i => i.id)
            this.selectedItemsCheckIn = this.data_checkin.map(i => i.id)
            this.selectedItemsCheckOut = this.data_checkout.map(i => i.id)
            this.form.value = null
            this.loading_submit = false

            if (this.data.length == 0) {
              this.$refs.text.focus();
            }

            // check qr valid
            var is_valid = false;
            for (let i = 0; i <= this.data.length - 1; i++) {
              if ((this.data[i].checkin_status !== null && (this.data[i].checkin_status.action == 'check in' || this.data[i].checkin_status.action == 'in class'))) {
                is_valid = true;
                break;
              }
              if (is_valid) {
                break;
              }
            }
            if (!is_valid) {
              this.clearPage();
              this.loading_submit = false
              this.$refs.text.focus();
              this.showErrorMessage('Invalid QR Code, Please try again');
              sendMessageToDiscord("parent self checkin", "scan", "err invalid qr | " + temp_input);
            }

        }).catch ((err) => {
            this.data = []
            this.form.value = null
            this.loading_submit = false
            this.$refs.text.focus();
            this.clearPage();
            this.showErrorMessage('Invalid QR Code, Please try again');
            // sendMessageToDiscord("parent self checkin", "scan", "err | " + temp_input);
        })
        this.$refs.text.focus()
    },
    async checkInSelect(id) {
      this.loading_submit = true
      this.form.ikid_id = id;
      this.form.status = 2;
      await ikid.changeStatusKidForParentSelfCheckout(this.form)
      .then(async res => {
        await this.connectToPrinter(id);
      }).catch((err) => {
        console.log(err);
        this.loading_submit = false;
        this.clearPage();
        this.showErrorMessage('Error, Please try again');
      })
      this.loading_submit = false
      this.clearPage();
    },
    async checkInAll() {
      this.loading_submit = true
      let hasError = false;
      await Promise.all(
        this.selectedItemsCheckIn.map(async (i) => {
          if (hasError) return;
          this.form.ikid_id = i;
          this.form.status = 2;
          await ikid.changeStatusKidForParentSelfCheckout(this.form)
          .then(async res => {
            await new Promise(resolve => setTimeout(resolve, 2000)); // 2-second delay
            await this.connectToPrinter(i);
          }).catch((err) => {
            console.log(err);
            hasError = true;
            this.loading_submit = false;
            this.clearPage();
            this.showErrorMessage('Error, Please try again');
          });
        })
      );
      this.loading_submit = false
      this.clearPage();
    },
    async checkOutSelect(id) {
      this.loading_submit = true
      this.form.ikid_id = id;
      this.form.status = 3;
      await ikid.changeStatusKidForParentSelfCheckout(this.form)
      .then(async res => {
        // await this.connectToPrinter(id);
      }).catch((err) => {
        console.log(err);
        this.loading_submit = false;
        this.clearPage();
        this.showErrorMessage('Error, Please try again');
      })
      this.loading_submit = false
      this.clearPage();
    },
    async checkOutAll() {
      this.loading_submit = true
      let hasError = false;
      await Promise.all(
        this.selectedItemsCheckOut.map(async (i) => {
          if (hasError) return;
          this.form.ikid_id = i;
          this.form.status = 3;
          await ikid.changeStatusKidForParentSelfCheckout(this.form)
          .then(async res => {
            // await this.connectToPrinter(i);
          }).catch((err) => {
            console.log(err);
            hasError = true;
            this.loading_submit = false;
            this.clearPage();
            this.showErrorMessage('Error, Please try again');
          });
        })
      );
      this.loading_submit = false
      this.clearPage();
    },
    async connectToPrinter(id) {
      const firstname = this.data.find(item => item.id === id).firstname;
      const lastname = this.data.find(item => item.id === id).lastname;
      const class_id = this.data.find(item => item.id === id).ikid_class.name;
      const check_time = moment().format('DD/MM/YYYY HH:mm:ss');
      const barcode = this.data.find(item => item.id === id).barcode;

      try {
        await this.sendPrintJob({
          firstname: firstname,
          lastname: lastname,
          class_id: class_id,
          check_time: check_time,
          barcode: barcode
        });
      } catch (error) {
        console.log('Error connecting to printer:', error);
        console.log('ID:', id);
      }
    },
    sendPrintJob(payload) {
      return axios.post(
        'http://localhost:3000/print',
        payload,
        {
          timeout: 5000,
        }
      );
    },
    openPinModal() {
      this.showPinModal = true;
      this.showPrintModal = false;
      this.pinInput = '';
    },
    closeAdminPopup() {
      this.showPinModal = false;
      this.showPrintModal = false;
      this.pinInput = '';
    },
    appendPinDigit(digit) {
      if (this.pinInput.length >= 4) return;
      this.pinInput += digit;
    },
    submitPin() {
      if (this.pinInput === this.defaultPin) {
        this.showPinModal = false;
        this.showPrintModal = true;
        return;
      }
      this.closeAdminPopup();
    },
    async printDummyLabel() {
      const check_time = moment().format('DD/MM/YYYY HH:mm:ss');
      try {
        await this.sendPrintJob({
          firstname: 'John',
          lastname: 'Doe',
          class_id: 'Dummy Class',
          check_time: check_time,
          barcode: 'DUMMY123456',
        });
      } catch (error) {
        // silent by request
      }
      this.closeAdminPopup();
    },
    getPhoto(data) {
      if (data === null || data === ' ') {
        return 'data:image/png;base64,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';
      } else {
        return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename;
      }
    },
    isSelected(id){
      const isExist = this.selectedItems.find(i => i === id)
      return !!isExist
    },
    handleSelect(data){
      const isExist = this.selectedItems.find(i => i === data.id)
      if(isExist){
        this.selectedItems = this.selectedItems.filter(i => i !== data.id)
      }else{
        this.selectedItems.push(data.id)
      }
    },
    showErrorMessage(message) {
      this.error_message = message;
      setTimeout(() => {
        this.error_message = '';
      }, 2000);
    },

  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Itim&display=swap');

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: green;
  margin: auto;
  box-sizing: border-box;
  max-width: 100%;
}

.loading_overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading_spinner {
  width: 70px;
  height: 70px;
  border: 10px solid #fff;
  border-top: 10px solid #ffcc00;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error_overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.error_message {
  font-size: 1.5rem;
  font-family: "Itim", cursive;
  color: #fff;
  background-color: #ff4444;
  padding: 20px 40px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.container_wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.title_section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* height: 180px; */
  height: 15%;
  background-color: #ffcc00;
  border-bottom: 2px solid #ff9900;
}

.title {
  width: 50%;
  font-size: 2.5rem;
  font-family: "Itim", cursive;
  color: #333;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.scan {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.scan_input {
  width: 70%;
  padding: 10px 15px;
  font-size: 1.2rem;
  font-family: "Itim", cursive;
  border: 2px solid #ffcc00;
  border-radius: 10px;
  /* background: #fff url('/path/to/doodle-background.png') no-repeat center; */
  background-size: cover;
  color: #333;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  outline: none;
  transition: all 0.3s ease;
}

.scan_input:focus {
  border-color: #ff9900;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.scan_input::placeholder {
  color: #999;
  font-style: italic;
}

.btn_scan {
  padding: 10px 20px;
  font-size: 1.2rem;
  font-family: "Itim", cursive;
  color: #fff;
  background-color: #ff9900;
  border: 2px solid #ffcc00;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.btn_scan:hover {
  background-color: #ffcc00;
  border-color: #ff9900;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.btn_scan:active {
  background-color: #ff8800;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn_clear {
  padding: 10px 20px;
  font-size: 1.2rem;
  font-family: "Itim", cursive;
  color: #fff;
  background-color: #ff4444;
  border: 2px solid #ff6666;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.btn_clear:hover {
  background-color: #ff6666;
  border-color: #ff4444;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.btn_clear:active {
  background-color: #cc3333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.card_header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  margin-bottom: 4px;
}
.card_gender img{
  width: 30px;
}
.content_section {
  height: 100%;
  /* overflow: visible; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  background-color: #fff;
}

.in_section, .out_section {
  /* padding-left: 10px;
  padding-right: 10px; */
  padding: 10px 20px;
  width: 100%;
  height: 48%;
  background-color: #f9f9f9;
  border: 2px dashed #ffcc00;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  gap: 20px;
  align-items: center;
  /* overflow: auto; */
}

.card_container {
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  width: calc(100% - 200px);
  height: 100%;
}

.button_submit_container {
  max-width: 10%;
  width: 10%;
  height: 60%;
  background-color: #4caf50;
  border: 2px solid #66bb6a;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
}

.button_submit_container:hover {
  background-color: #66bb6a;
  border-color: #4caf50;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.button_submit_container:active {
  background-color: #388e3c;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.button_submit_container_checkout {
  max-width: 10%;
  width: 10%;
  height: 60%;
  background-color: #ff4444;
  border: 2px solid #ff6666;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
}

.button_submit_container_checkout:hover {
  background-color: #ff6666;
  border-color: #ff4444;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.button_submit_container_checkout:active {
  background-color: #cc3333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.text_checkin {
  font-size: 1.5rem;
  font-family: "Itim", cursive;
  color: #fff;
}

.btn_checkin {
  width: 25%;
  height: auto;
}

.btn_checkin img {
  width: 100%;
  height: auto;
}

.card1 {
  width: 100%;
  height: 100%;
  flex: 1 1 calc(25% - 20px);
  max-width: calc(30% - 20px);
  max-height: calc(100% - 20px);
  /* aspect-ratio: 2 / 1; */
  background-color: #ffcc00;
  border: 2px solid #ff9900;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-family: "Itim", cursive;
  font-size: 1.2rem;
  color: #333;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px;
  /* margin: auto; */
}

.selected {
  box-shadow: 0 0 15px #007bff;
  transition: 0.2s;
}

.card_content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.card_title {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  /* margin-bottom: 10px; */
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card_body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  gap: 20px;
  height: calc(100% - 99px);
}

.card_body_left {
  width: 50%;
  height: 100%;
  max-width: 50%;
  display: flex;
  justify-content: end;
}
.card_body_right {
  width: 50%;
  height: 100%;
  max-width: 50%;
}
.card_image {
  /* width: 50%;
  height: auto;
  max-width: calc(50% - 50px); */
  width: 100%;
  max-width: 100%;
  /* aspect-ratio: 1; */
  background-color: #fff;
  border: 2px solid #ff9900;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  color: #999;
}

.card_image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.card_text {
  width: 100%;
  text-align: left;
  font-size: 15px;
  color: #333;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card_footer {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.card_footer .btn {
  padding: 8px 15px;
  font-size: 1rem;
  font-family: "Itim", cursive;
  color: #fff;
  background-color: #ff9900;
  border: 2px solid #ffcc00;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.card_footer .btn:hover {
  background-color: #ffcc00;
  border-color: #ff9900;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
}

.card_footer .btn:active {
  background-color: #ff8800;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.admin_gear_button {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 50%;
  background-color: #333;
  color: #fff;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  z-index: 1200;
}

.admin_modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1300;
}

.admin_modal {
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  min-width: 320px;
}

.admin_modal_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.admin_modal_title {
  font-size: 1.5rem;
  font-family: "Itim", cursive;
}

.admin_pin_input {
  width: 140px;
  text-align: center;
  font-size: 1.8rem;
  letter-spacing: 8px;
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 6px 8px;
}

.pin_pad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  width: 220px;
}

.pin_key,
.pin_cancel_button,
.pin_enter_button,
.test_print_button {
  border: none;
  border-radius: 8px;
  padding: 10px;
  font-size: 1.2rem;
  font-family: "Itim", cursive;
  cursor: pointer;
}

.pin_key {
  background-color: #f2f2f2;
}

.pin_cancel_button,
.pin_enter_button,
.test_print_button {
  width: 220px;
  color: #fff;
}

.pin_cancel_button {
  background-color: #9e9e9e;
}

.pin_enter_button,
.test_print_button {
  background-color: #ff9900;
}

</style>
